
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/balance/verification",
      function () {
        return require("private-next-pages/dashboard/balance/verification.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/balance/verification"])
      });
    }
  